import { Action, action } from "easy-peasy";

export interface BankSummaryStoreModel {
  scoreboard: any;
  advancesData: any;
  bankStatementData: any;
  positionCount : any;

  setScoreboard: Action<BankSummaryStoreModel, any>;
  setAdvancesData: Action<BankSummaryStoreModel, any>;
  setBankStatementData: Action<BankSummaryStoreModel, any>;
  setPositionCount: Action<BankSummaryStoreModel, any>;
  resetStore: Action<BankSummaryStoreModel>;
}

const bankSummaryStore: BankSummaryStoreModel = {
  scoreboard: null,
  advancesData: [],
  bankStatementData: [],
  positionCount: 0,

  setScoreboard: action((state, payload) => {
    state.scoreboard = payload;
  }),

  setAdvancesData: action((state, payload) => {
    state.advancesData = payload;
  }),

  setBankStatementData: action((state, payload) => {
    state.bankStatementData = payload;
  }),


  setPositionCount: action((state, payload) => {
    state.positionCount = payload;
  }),

  resetStore: action((state) => {
    state.scoreboard = null;
    state.advancesData = [];
    state.bankStatementData = [];
    state.positionCount=0;
  }),
};

export default bankSummaryStore;
